import React from "react";
import Card from "react-bootstrap/Card";
import CardHeader from "./CardHeaderImportData";
import CardBody from "./CardBodyImportData";

const TimeCardImportData = ({ index, item, timeFormat, globalEditedId, setGlobalEditedId }) => {
  return (
    <Card className="text-center card-bg">
      <CardHeader index={index} item={item} />
      <CardBody 
        item={item} 
        timeFormat={timeFormat} 
        globalEditedId={globalEditedId}
        setGlobalEditedId={setGlobalEditedId}
      />
    </Card>
  );
};

export default TimeCardImportData;